export const RENEW_OR_REMOVE_AUTH_AGENT_BEGIN = "RENEW_OR_REMOVE_AUTH_AGENT_BEGIN";
export const RENEW_OR_REMOVE_AUTH_AGENT_SUCCESS = "RENEW_OR_REMOVE_AUTH_AGENT_SUCCESS";
export const RENEW_OR_REMOVE_AUTH_AGENT_FAILURE = "RENEW_OR_REMOVE_AUTH_AGENT_FAILURE";